var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.05 63.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #0d5227;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2.23px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e8f3e7;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.05,43.21c0,11.1-8.99,20.09-20.09,20.09H15.82c-3.08,0-5.58-2.5-5.58-5.58V19.77c0-6.16,5-11.16,11.16-11.16H60.47c3.08,0,5.58,2.5,5.58,5.58,0,0,0,29.02,0,29.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.19,20.99c-1.34-2.42-1.89-5.2-1.59-7.95,.3-2.75,1.45-5.34,3.29-7.41,1.84-2.07,4.27-3.52,6.96-4.16,2.69-.63,5.52-.42,8.08,.62l-8.37,9.07,1.18,5.51,5.51,1.18,9.07-8.37c1.04,2.57,1.25,5.39,.62,8.08-.63,2.69-2.08,5.13-4.16,6.96-2.07,1.84-4.66,2.98-7.41,3.29-2.75,.3-5.53-.25-7.95-1.59l-11.73,13.6c-.94,.94-2.22,1.47-3.56,1.47s-2.61-.53-3.56-1.47c-.94-.94-1.47-2.22-1.47-3.56s.53-2.61,1.47-3.56l13.6-11.73Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.adc4893f8a829b7d7eec480d88d95c0e.svg";
export { ForwardRef as ReactComponent };